import { noop } from 'lodash';
import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import { ContainerWidthProvider } from '../../../../util/responsiveness';
import Flex from '../../../Flex';
import AppLayout from '../../AppLayout';
import AppLayoutRow from '../../AppLayoutRow';

import HeaderRow from './HeaderRow';
import MainAreaRow from './MainAreaRow';
import OuterLeftNav from './OuterLeftNav';
import SubHeaderRow from './SubHeaderRow';
import type { TemplateProps } from './Template.types';

const Template: FC<PropsWithChildren<TemplateProps>> = ({
  header,
  headerDepth,
  subHeader,
  banner,
  hasHeroBackground,
  footer,
  openContentSidebarAriaLabel,
  closeContentSidebarAriaLabel,
  hasBackButton,
  backButtonAriaLabel = '',
  onBackButtonClick = noop,
  children,
  leftNav,
  outerLeftNav,
  backgroundColor,
  headerBackgroundColor,
  removeContentPadding = false,
  pinnedCollapsibleRightRail = false,
  unifiedSidebar = false,
  scrollPaddingTop,
  scrollPaddingBottom,
}) => {
  const bannerRow = banner ? <AppLayoutRow>{banner}</AppLayoutRow> : null;

  return (
    <AppLayout
      disableNativePageScroll={true}
      closeContentSidebarAriaLabel={closeContentSidebarAriaLabel}
      openContentSidebarAriaLabel={openContentSidebarAriaLabel}
      hasBackButton={!!hasBackButton}
      hasOuterLeftNav={!!outerLeftNav}
      height="100dvh"
      backgroundColor={backgroundColor}
      removeContentPadding={removeContentPadding}
      pinnedCollapsibleRightRail={pinnedCollapsibleRightRail}
      unifiedSidebar={unifiedSidebar}
    >
      <HeaderRow depth={headerDepth} backgroundColor={headerBackgroundColor}>
        {header}
      </HeaderRow>
      <SubHeaderRow>{subHeader}</SubHeaderRow>
      {bannerRow}
      <AppLayoutRow grow={1}>
        <OuterLeftNav>{outerLeftNav}</OuterLeftNav>
        <Flex grow={1} direction="column" height="100%" maxHeight="100%">
          <ContainerWidthProvider>
            <MainAreaRow
              hasHeroBackground={hasHeroBackground}
              footer={footer}
              leftNav={leftNav}
              backButtonAriaLabel={backButtonAriaLabel}
              onBackButtonClick={onBackButtonClick}
              scrollPaddingTop={scrollPaddingTop}
              scrollPaddingBottom={scrollPaddingBottom}
            >
              {children}
            </MainAreaRow>
          </ContainerWidthProvider>
        </Flex>
      </AppLayoutRow>
    </AppLayout>
  );
};

export default Template;
